module.exports = __webpack_public_path__ + "static/img/kitchen.d251806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/kitchen.jpg
// module id = 4lfa
// module chunks = 0